'use es6';

import Immutable from 'immutable';
const defaults = {
  id: null,
  calloutId: null,
  internalName: '',
  headline: '',
  description: '',
  illustration: '',
  gradientColor: '',
  buttonText: '',
  collectionId: null,
  externalUrl: '',
  published: 0,
  updatedAt: 0,
  updatedBy: ''
};
export default class FeaturedCalloutListing extends Immutable.Record(defaults) {
  static from(json) {
    return new FeaturedCalloutListing(json);
  }

  isPreviewable() {
    const {
      headline,
      description,
      illustration,
      gradientColor,
      buttonText
    } = this;
    return Boolean(headline && description && illustration && gradientColor && buttonText);
  }

}